import { useFormContext, Controller } from 'react-hook-form';
import { SxProps } from '@mui/system';
import { Rating, RatingProps, Stack, Theme } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';
import { useTranslation } from 'react-i18next';
import { ReactComponent as StarIcon } from '../../assets/icons/star.svg';
import { primaryDark, secondaryBlue, secondaryPink } from '../../utils/color';

type Props = {
  name: string;
  required?: boolean;
  labelAdornment?: JSX.Element | null;
  helperStyles?: SxProps<Theme>;
} & RatingProps;

const ControlledRatingInput = ({ name, required, labelAdornment, sx, ...props }: Props) => {
  const { control, getFieldState } = useFormContext();
  const { t } = useTranslation();
  return (
    <Controller
      control={control}
      name={name}
      rules={required ? { required: t('errors.required') } : { required: false }}
      render={({ field: { onChange, value, ...field } }) => (
        <Stack direction="row" alignItems="center" spacing={1}>
          {required && getFieldState(name).error && (
            <ErrorIcon
              sx={{
                color: 'secondaryPink.500',
                mr: 1,
              }}
            />
          )}
          <Rating
            name={field.name}
            value={value || null}
            onChange={(event, newValue) => {
              onChange(newValue);
            }}
            icon={<StarIcon style={{ margin: '0 2px' }} fill={secondaryBlue[700]} />}
            emptyIcon={
              <StarIcon
                stroke={
                  required && getFieldState(name).error ? secondaryPink[500] : primaryDark[300]
                }
                fill="transparent"
                style={{ margin: '0 2px' }}
              />
            }
            {...props}
          />
        </Stack>
      )}
    />
  );
};

export default ControlledRatingInput;
